import Vue from "vue";
import VueFirestore from "vue-firestore";
import App from "./App.vue";
import router from "./router";
import firebase from "firebase/app";
import "firebase/firestore";
import ImageUploader from "vue-image-upload-resize";

Vue.config.productionTip = false;
Vue.use(VueFirestore);
Vue.use(ImageUploader);

const config = {
  apiKey: "AIzaSyBtadYcgOks97aKB52APqwNIPmmWCVB6VU",
  authDomain: "yolosunshine.firebaseapp.com",
  databaseURL: "https://yolosunshine.firebaseio.com",
  projectId: "yolosunshine",
  storageBucket: "yolosunshine.appspot.com",
  messagingSenderId: "1070355224223"
};

const firebaseApp = firebase.initializeApp(config);
export const db = firebaseApp.firestore();

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
